import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'campanyaEstadoPreparacion'
})
export class CampanyaEstadoPreparacionPipe implements PipeTransform {

  transform(value: unknown): unknown {
    let label = '';
    let cssClass = '';

    switch (value) {
      case '1':
        label = 'Pendiente';
        cssClass = 'badge-estado-info';
        break;
      case '2':
        label = 'En proceso';
        cssClass = 'badge-estado-warning';
        break;
      case '3':
        label = 'Finalizada';
        cssClass = 'badge-estado-success';
        break;
      case '8':
        label = 'Incidencia';
        cssClass = 'badge-estado-danger';
        break;
      default:
        return value;
    }

    return `<span class="badge ${cssClass}">${label}</span>`;
  }

}
